const protocol = window.location.protocol
const host = window.location.host.toLowerCase()
export const baseHost = host.split('.').slice(1).join('.')

/**
 * Takes subdomain and path options then returns a URL in the context of the current host environment
 * @param  {Object}  options                  - Default options
 * @param  {String}  options.subdomain [www]  -  Subdomain of external resource
 * @param  {String}  options.path      []     - Pathname of external resource
 * @return {string}                           - Complete URL
 */
export const appRoute = (options = {}) => {
  const opts = {
    subdomain: 'www',
    path: '',
    ...options
  }
  return `${protocol}//${opts.subdomain}.${baseHost}${opts.path}`
}

const aspenBaseUrl = (subdomain = 'user') => {
  return `${protocol}//${host.replace('www', subdomain)}`
}
const ashBaseUrl = `${protocol}//${host.replace('www', 'secure')}`
const microAppBaseUri = (process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'production' || process.env.APP_ENV === undefined) ? 'https://www.doxo.com' : `https://www.${process.env.APP_ENV}.doxo.com`
const microAppBillsPath = `${microAppBaseUri}/u/bills`
const legacyAboutPath = '/about/the-network/'
const legacyBusinessPath = '/business/'
const legacyPrivacyPolicyPath = '/legal/privacy-and-security-policy/'
const legacyPreventingFraudPath = '/about/fraud-scam-prevention/'
export const enableMicroApp = process.env.ENABLE_MICROAPP_RELEASE === 'true'

const siteUrls = {
  homeUrl: appRoute({ path: '/' }),
  iosAppUrl: 'https://doxo.io/iphone',
  androidAppUrl: 'https://doxo.io/android',
  aboutPath: legacyAboutPath,
  businessPath: legacyBusinessPath,
  insightsPath: '/insights/',
  providerSite: aspenBaseUrl('enterprise'),
  userSite: aspenBaseUrl(),
  secureSite: ashBaseUrl,
  privacySecurityPolicyPath: legacyPrivacyPolicyPath,
  termsOfServicePath: '/legal/terms-of-service/',
  dataTrackingUrl: 'https://www.doxo.com/w/privacy-policy/#data-tracking',
  paymentsInfoUrl: 'https://www.truexpayments.com',
  preventingFraudPath: legacyPreventingFraudPath,
  providerFaqUrl: 'https://support.doxo.com/hc/en-us/categories/115000004833-doxo-for-Business',
  securityPath: '/security/',
  supportUrl: 'https://support.doxo.com',
  chatUrl: 'https://doxo.io/chat',
  doxoplusMarketingPath: '/about/doxoplus',
  social: {
    facebookUrl: 'https://www.facebook.com/doxo',
    twitterUrl: 'https://twitter.com/doxo',
    linkedinUrl: 'https://www.linkedin.com/company/doxo'
  },
  microAppBills: microAppBillsPath,
  microAppSearch: `${microAppBaseUri}/u/search`,
  aboutDoxoPath: enableMicroApp ? `${microAppBaseUri}/w/about` : legacyAboutPath,
  doxoForBusinessPath: enableMicroApp ? `${microAppBaseUri}/w/biller` : legacyBusinessPath,
  doxoUrl: enableMicroApp ? microAppBillsPath : '/',
  fraudPreventionPath: enableMicroApp ? `${microAppBaseUri}/w/privacy-policy/fraud-prevention` : legacyPreventingFraudPath,
  privacyPolicyPath: enableMicroApp ? `${microAppBaseUri}/w/privacy-policy` : legacyPrivacyPolicyPath
}

export default siteUrls



// WEBPACK FOOTER //
// ./frontend/src/helpers/site_urls.js